/* Copyright Flexday Solutions LLC, Inc - All Rights Reserved

 * Unauthorized copying of this file, via any medium is strictly prohibited

 * Proprietary and confidential

 * See file LICENSE.txt for full license details.

 */

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { InputField } from '../../settings/fileUploaderPage/fileUploader.page.styled';
import SubmitButtonGroup from './submitButtonGroup';
import { STORAGE_SOURCE } from '../../../constants/dataSources';

const SharepointForm = (props) => {
  const [inputValues, setInputValues] = useState({
    name: '',
    storageConnectionId: props.storageConfigId,
    type: props.storageContainer,
    sourceType: STORAGE_SOURCE,
    params: {
      siteId: '',
      basePath: '',
      siteName: '',
    },
  });

  const [validationErrorLabel, setValidationErrorLabel] = useState('');

  const handleInputChange = (fieldName, value) => {
    setInputValues((prevState) => ({
      ...prevState,
      ...(fieldName.includes('.')
        ? { params: { ...prevState.params, [fieldName.split('.')[1]]: value } }
        : { [fieldName]: value }),
    }));
  };

  const clearValues = () => {
    setInputValues({
      name: '',
      storageConnectionId: props.storageConfigId,
      type: props.storageContainer,
      params: {
        siteId: '',
        basePath: '',
        siteName: '',
      },
    });
  };

  useEffect(() => {
    if (props.storageConfigId) {
      setInputValues((prevState) => ({
        ...prevState,
        storageConnectionId: props?.storageConfigId,
      }));
    }
  }, [props.storageConfigId]);

  const { t } = useTranslation();
  return (
    <>
      <InputField
        size="small"
        required
        fullWidth
        name="name"
        label="Name"
        value={inputValues.name}
        onChange={(e) => handleInputChange('name', e.target.value)}
      />
      <InputField
        sx={{ marginTop: 2 }}
        size="small"
        required
        fullWidth
        name="siteId"
        label="Site Id"
        value={inputValues.params.siteId}
        onChange={(e) => handleInputChange('params.siteId', e.target.value)}
      />
      <InputField
        sx={{ marginTop: 2 }}
        size="small"
        required
        fullWidth
        name="basePath"
        label="Base Path"
        value={inputValues.params.basePath}
        onChange={(e) => handleInputChange('params.basePath', e.target.value)}
      />
      <InputField
        sx={{ marginTop: 2 }}
        size="small"
        required
        fullWidth
        name="siteName"
        label="Site Name"
        value={inputValues.params.siteName}
        onChange={(e) => handleInputChange('params.siteName', e.target.value)}
      />
      <SubmitButtonGroup
        data={inputValues}
        onClear={clearValues}
        errorMessage={validationErrorLabel}
      />
    </>
  );
};

SharepointForm.propTypes = {
  storageContainer: PropTypes.string,
  storageConfigId: PropTypes.string,
};

export default SharepointForm;
